var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.6719 42.5C83.6719 19.7559 65.2441 1.32812 42.5 1.32812C19.7559 1.32812 1.32812 19.7559 1.32812 42.5C1.32812 63.0494 16.3841 80.0826 36.0669 83.1738V54.4017H25.6079V42.5H36.0669V33.4289C36.0669 23.111 42.2095 17.4117 51.6176 17.4117C56.1232 17.4117 60.8348 18.2152 60.8348 18.2152V28.3422H55.6418C50.5285 28.3422 48.9331 31.5164 48.9331 34.772V42.5H60.3517L58.5255 54.4017H48.9331V83.1738C68.6159 80.0826 83.6719 63.0494 83.6719 42.5Z",
    fill: "#3ECF7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookHover);
export default __webpack_public_path__ + "static/media/facebook_hover.d9f94090ae14acd90db9943c64287545.svg";
export { ForwardRef as ReactComponent };